import { render, staticRenderFns } from "./AssetGroup.vue?vue&type=template&id=0865941a&"
import script from "./AssetGroup.vue?vue&type=script&lang=js&"
export * from "./AssetGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports